@import url('../../../node_modules/@splidejs/splide/dist/css/splide.min.css');

:host, .splide {
  .splide__arrow {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 48px;
    height: 48px;

    background-color: $color-base-brand-yellow;
    opacity: 1;

    box-shadow: 0px 0px 16px 0px rgba(160, 160, 167, 0.25);

    &:disabled {
      visibility: hidden;
    }
  }

  .splide__arrow--prev {
    left: -64px;
  }
  .splide__arrow--next {
    right: -64px;
  }

  .splide__pagination {
    bottom: -24px;
    gap: 16px;
  }
  .splide__pagination__page {
    background-color: $color-base-gray-gray-3;
    opacity: 1;
    &.is-active {
      background-color: $color-base-brand-yellow;
      transform: none;
      opacity: 1;
    }
  }
}